module.exports = __webpack_public_path__ + "img/check-mark-green.97f42350.svg";